import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=22f1d938&scoped=true&lang=pug&"
import script from "./Manager.vue?vue&type=script&lang=js&"
export * from "./Manager.vue?vue&type=script&lang=js&"
import style0 from "./Manager.vue?vue&type=style&index=0&id=22f1d938&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1d938",
  null
  
)

/* custom blocks */
import block0 from "./Manager.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports